export function target() {
  return ['SimpleTextColumns'].includes(this.module);
}

export function migrate() {
  if (this.module === 'SimpleTextColumns') {
    this.module = 'Icons';
    this.name = 'Fotos + texto em colunas';

    if (this.data.columns) {
      this.data.items = this.data.columns.map((column) => ({
        text: column.text,
      }));
      delete this.data.columns;
    }

    this.data.sectionTitle = this.data.title;
    this.data.sectionSubtitle = this.data.subtitle;
    this.data.sectionTitleWeight = this.data.titleWeight;

    delete this.data.title;
    delete this.data.subtitle;
    delete this.data.titleWeight;
  }

  return this.data;
}
